// Configuration for debug logging
export const DEBUG_CONFIG = {
  // Set to false to disable all debug logs
  ENABLE_LOGS: true,
  
  // Individual feature flags (only work if ENABLE_LOGS is true)
  TRANSCRIPTION: false,
  TIMER: false,
  TIMESTAMP: true,
  SAVE: true,
  HOOK: true,
  DEEPGRAM: false,
  DEDUP: false,
  DIALOG: false // New flag for dialog-related logs
};

// Helper function for conditional logging
export const debugLog = (category: keyof typeof DEBUG_CONFIG, ...args: any[]) => {
  if (DEBUG_CONFIG.ENABLE_LOGS && DEBUG_CONFIG[category]) {
    console.log(...args);
  }
};

export const debugError = (category: keyof typeof DEBUG_CONFIG, ...args: any[]) => {
  if (DEBUG_CONFIG.ENABLE_LOGS && DEBUG_CONFIG[category]) {
    console.error(...args);
  }
};

export const debugWarn = (category: keyof typeof DEBUG_CONFIG, ...args: any[]) => {
  if (DEBUG_CONFIG.ENABLE_LOGS && DEBUG_CONFIG[category]) {
    console.warn(...args);
  }
};
